import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import dayjs from 'dayjs'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../api'
import { useAsync } from '../../hooks'
import { PageHeader } from '../Common'
import Loading from '../Loading'
import Form from './Form'

export default function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()

  const getPatient = useCallback(
    () =>
      api.patients.get(id).then(patient => ({
        ...patient,
        birthDate: dayjs(patient.birthDate)
      })),
    [id],
  )
  const { pending, value } = useAsync(getPatient)

  const onSubmit = useCallback(
    async (
      {
        firstName,
        lastName,
        birthDate,
        email,
        mobilePhone,
        homePhone,
        addressStreet,
        addressApt,
        addressCity,
        addressState,
        addressCountry,
        addressZipCode,
        atrialFibrilationFlutterDisease,
        anticoagulatedDisease,
        icdCodeIds,
        deviceIcdCodeId,
        enrolled,
        paired,
        homeMonitorSerialNumber,
        insuranceProviderId,
        insurancePolicyNumber,
        provider,
        pcpName,
        pcpPhoneNumber,
        pcpFaxNumber,
        alertRecipientIds,
        remoteMonitoring,
        practiceMrn,
        medicalProviderId,
        officeLocationId,
        alertForAnyAfib,
        oacContraindicated,
      },
      formikHelpers,
    ) => {
      const { setErrors } = formikHelpers
      try {
        await api.patients.update(id, {
          firstName,
          lastName,
          birthDate: birthDate.toISOString(),
          email: email || null,
          mobilePhone: mobilePhone || null,
          homePhone: homePhone || null,
          addressStreet,
          addressApt: addressApt || null,
          addressCity,
          addressState: addressState || null,
          addressCountry,
          addressZipCode,
          atrialFibrilationFlutterDisease,
          anticoagulatedDisease,
          icdCodeIds,
          deviceIcdCodeId: deviceIcdCodeId || null,
          enrolled,
          paired,
          homeMonitorSerialNumber,
          insuranceProviderId: insuranceProviderId || null,
          insurancePolicyNumber,
          provider,
          pcpName,
          pcpPhoneNumber,
          pcpFaxNumber,
          alertRecipientIds,
          remoteMonitoring,
          practiceMrn,
          medicalProviderId: medicalProviderId || null,
          officeLocationId: officeLocationId?.key || officeLocationId,
          practiceId: value?.practiceId,
          alertForAnyAfib,
          oacContraindicated,
        })
        message.success('Patient successfully updated')
        navigate(-1)
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, error => error[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [navigate, id, value],
  )

  if (pending) return <Loading large />

  return (
    <div>
      <PageHeader title="Update Patient" onBack={() => navigate(-1)} />
      <Form patientData={value} onSubmit={onSubmit} />
    </div>
  )
}
